import requests from 'service/api'
import AsyncSearchSelect from '../async-search-select'
import { asOptions, firstOption } from 'lib/asyncList'

export function SelectWashingAdditionalInstructions({ name, brrand }) {
  const isHome = brrand === 'ZaraHome'
  const mapPhrase = ({ id, name: label }) => ({ value: id, label })
  const list = (params) =>
    isHome ? requests.additionalPhrases.washListHome(params) : requests.additionalPhrases.washList(params)

  return (
    <AsyncSearchSelect
      name={name}
      fetchSelected={(id) => firstOption(list({ selected: id }), mapPhrase)}
      fetchOptions={(search) => asOptions(list({ search, limit: 20 }), mapPhrase)}
    />
  )
}
